module.exports = __webpack_public_path__ + "assets/img/advantage4.a09d5127.png";